import React, { useContext, useReducer } from 'react'
import { t } from 'i18next';
import { logout } from '../../services/login';
import { createPersonToVisitService, deletePersonToVisitService, editPersonToVisitService, getListOfPeopleToVisitService, getSettingService, setSettingService } from '../../services/Settings';
import InstanceContext from '../InstanceContext/InstanceContext';
import { CLEAN_PEOPLE_TO_VISIT_ERROR, CLEAN_PEOPLE_TO_VISIT_STATE, CRUD_PEOPLE_TO_VISIT, GET_PEOPLE_TO_VISIT, SET_AMOUNT_OF_PEOPLE_TO_VISIT, SET_FILTERS, SET_PEOPLE_TO_VISIT_DATA } from './types';
import PeopleToVisitManagementReducer from './PeopleToVisitManagementReducer';
import PeopleToVisitManagementContext from './PeopleToVisitManagementContext';

const PeopleToVisitManagementState = ({ children }) => {

    const { instanceInfoGet } = useContext(InstanceContext);

    const initialState = {
        peopleToVisitToConfig: [],
        personData: {
            documentNumber: '',
            name: '',
            lastName: '',
            openingCodes: [],
            buildingIds: [],
            sectorId: '',
            enabled: 1
        },
        amountOfPeopleAllowed: 0,
        isFetching: false,
        filters: {
            searchText: '',
            /* peopleToVisitId: '', */
            regFrom: 1,
            pageLength: 10
        },
        totalPages: null,
        error: {
            ok: false,
            text: ''
        },
        responsePeopleToVisitService: {
            show: false,
            type: '',
            text: '',
        }
    }

    const [state, dispatch] = useReducer(PeopleToVisitManagementReducer, initialState);

    const setFilters = (filter) => {
        dispatch({
            type: SET_FILTERS,
            payload: filter
        });
    }

    const setFetching = (value) => {
        dispatch({
            type: 'SET_FETECHING',
            payload: value
        });
    }

    const getPeopleToVisitManagement = async (filters) => {
        try {
            const filterToSearch = [];

            setFetching(true);

            for (const [key, value] of Object.entries(filters)) {
                filterToSearch.push(`&${key}=${value}`);
            }

            setFilters(filters);
            const items = await getListOfPeopleToVisitService(filterToSearch.join(''));

            if (items.ok) {
                dispatch({
                    type: GET_PEOPLE_TO_VISIT,
                    payload: {
                        peopleToVisitToConfig: items.data.response.peopleToVisit,
                        totalPages: items.data.response.totalPages,
                        responsePeopleToVisitService: {
                            show: false,
                            type: 'SUCCESS',
                            text: '',
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: GET_PEOPLE_TO_VISIT,
                    payload: {
                        peopleToVisitToConfig: state.peopleToVisitToConfig,
                        totalPages: state.totalPages,
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: GET_PEOPLE_TO_VISIT,
                payload: {
                    peopleToVisitToConfig: state.peopleToVisitToConfig,
                    totalPages: state.totalPages,
                    responsePeopleToVisitService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const getPeopleToVisit = async (id) => {
        try {
            const personId = id ? `peopleToVisitId=${id}` : '';

            setFetching(true);

            const items = await getListOfPeopleToVisitService(personId);

            const person = items.data.response?.peopleToVisit[0] ? items.data.response.peopleToVisit[0] : null;

            if (items.ok) {

                const openingsToSelector = [];
                const buildingsToSelector = [];

                person.openings.forEach(opening => {
                    openingsToSelector.push(opening.openingCode);
                });

                person.buildings.forEach(building => {
                    buildingsToSelector.push(building.buildingId);
                });

                person.openingCodes = openingsToSelector;
                person.buildingIds = buildingsToSelector;
                person.sectorId = person.sector ? person.sector.sectorId : null;

                setPersonToVisitData(person);
                return person

            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: GET_PEOPLE_TO_VISIT,
                    payload: {
                        peopleToVisitToConfig: state.peopleToVisitToConfig,
                        totalPages: state.totalPages,
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: GET_PEOPLE_TO_VISIT,
                payload: {
                    peopleToVisitToConfig: state.peopleToVisitToConfig,
                    totalPages: state.totalPages,
                    responsePeopleToVisitService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const createPersonToVisit = async (person) => {
        try {
            setFetching(true);

            const items = await createPersonToVisitService(person);

            if (items.ok) {
                dispatch({
                    type: CRUD_PEOPLE_TO_VISIT,
                    payload: {
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${t('PERSON_TO_VISIT')} ${t('CREATED_SUCCESSFULLY')}`,
                        }
                    }
                })
                instanceInfoGet();
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('DNI_ID_ALREADY_EXIST');
                        break;
                    case 'OPENING_HAS_BUILDINGS':
                        errorMsg = t('OPENING_HAS_BUILDINGS_ERROR_SELECTED');
                        break;
                    case 'NONEXISTENCE_ENTITY':
                        errorMsg = t('NOT_EXIST_SECTOR_ERROR');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_PEOPLE_TO_VISIT,
                    payload: {
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg
                        },
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_PEOPLE_TO_VISIT,
                payload: {
                    responsePeopleToVisitService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR')
                    },
                }
            });
        }
    }

    const editPersonToVisit = async (person) => {
        try {
            setFetching(true);

            const items = await editPersonToVisitService(person);

            if (items.ok) {
                dispatch({
                    type: CRUD_PEOPLE_TO_VISIT,
                    payload: {
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${t('PERSON_TO_VISIT')} ${t('EDITED_SUCCESSFULLY')}`,
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('DNI_ID_ALREADY_EXIST');
                        break;
                    case 'OPENING_HAS_BUILDINGS':
                        errorMsg = t('OPENING_HAS_BUILDINGS_ERROR_SELECTED');
                        break;
                    case 'RESOURCE_IN_VISITED':
                        errorMsg = t('RESOURCE_IN_VISITED_ERROR');
                        break;
                    case 'NONEXISTENCE_ENTITY':
                        errorMsg = t('NOT_EXIST_SECTOR_ERROR');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_PEOPLE_TO_VISIT,
                    payload: {
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_PEOPLE_TO_VISIT,
                payload: {
                    responsePeopleToVisitService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const deletePerson = async (query) => {
        try {
            setFetching(true);

            const items = await deletePersonToVisitService(query);

            if (items.ok) {
                dispatch({
                    type: CRUD_PEOPLE_TO_VISIT,
                    payload: {
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${t('PERSON_TO_VISIT')} ${t('DELETED_SUCCESSFULLY')}`,
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('PERSON_VISITED_ERROR');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_PEOPLE_TO_VISIT,
                    payload: {
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'SUCCESS',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_PEOPLE_TO_VISIT,
                payload: {
                    responsePeopleToVisitService: {
                        show: true,
                        type: 'SUCCESS',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const cleanPeopleToVisitState = () => {
        dispatch({
            type: CLEAN_PEOPLE_TO_VISIT_STATE,
        });
    }

    const removeWarningModal = (type) => {
        dispatch({
            type: CLEAN_PEOPLE_TO_VISIT_ERROR,
        });
    }

    const setPersonToVisitData = (person) => {
        dispatch({
            type: SET_PEOPLE_TO_VISIT_DATA,
            payload: person
        });
    }

    const getAmountOfPeopleToVisit = async (filters) => {
        try {
            const params = '?keyword=maximum_people_to_visit';

            const items = await getSettingService(params);

            if (items.ok) {
                dispatch({
                    type: SET_AMOUNT_OF_PEOPLE_TO_VISIT,
                    payload: {
                        amountOfPeopleAllowed: items.data.response[0].setting_value,
                        responsePeopleToVisitService: {
                            show: false,
                            type: 'SUCCESS',
                            text: '',
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: SET_AMOUNT_OF_PEOPLE_TO_VISIT,
                    payload: {
                        amountOfPeopleAllowed: state.amountOfPeopleAllowed,
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: SET_AMOUNT_OF_PEOPLE_TO_VISIT,
                payload: {
                    amountOfPeopleAllowed: state.amountOfPeopleAllowed,
                    responsePeopleToVisitService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const setAmountOfPeopleToVisit = async (setting) => {
        try {

            const response = await setSettingService(setting);

            if (response.ok) {

                const msgSuccessfully = t('EDITED_SUCCESSFULLY');
                let txt = msgSuccessfully.charAt(0).toUpperCase() + msgSuccessfully.slice(1)

                dispatch({
                    type: 'CHANGE_SETTING',
                    payload: {
                        amountOfPeopleAllowed: setting.setting_value,
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'SUCCESS',
                            text: txt,
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (response.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'CHANGE_SETTING',
                    payload: {
                        amountOfPeopleAllowed: state.amountOfPeopleAllowed,
                        responsePeopleToVisitService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CHANGE_SETTING',
                payload:
                {
                    amountOfPeopleAllowed: state.amountOfPeopleAllowed,
                    responsePeopleToVisitService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
            return {
                ok: false
            }
        }
    }

    return (
        <PeopleToVisitManagementContext.Provider
            value={{
                peopleToVisitManagementState: state,
                getPeopleToVisitManagement,
                createPersonToVisit,
                editPersonToVisit,
                deletePerson,
                cleanPeopleToVisitState,
                removeWarningModal,
                setPersonToVisitData,
                getAmountOfPeopleToVisit,
                setAmountOfPeopleToVisit,
                getPeopleToVisit
            }}
        >
            {children}
        </PeopleToVisitManagementContext.Provider>
    )
}

export default PeopleToVisitManagementState